import React, { useContext, useEffect, useState } from 'react';
import { Row, Col, Stack } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import 'assets/styles/common.scss';
import { LocaleContext } from 'routes/Router';
import { FormattedMessage, useIntl } from 'react-intl';
import trash from 'assets/images/Dashboard/trash.png';
import ReusableButton from 'components/common/Button';
import EditUnderlineIcon from 'assets/images/Category/editUnderlineIcon.png';
import SwitchInput from 'components/common/Input/SwitchInput';
import Avtar from 'assets/images/Dashboard/avtar.png';
import AvtarVideoIcon from 'assets/images/Dashboard/videoIcon2.png';
import {
  superAdminAddAssociationCampaign,
  superAdminAddBrandCampaign,
  superAdminAddDiscountCampaign,
  superAdminAddLinkedCampaign,
} from 'routes/AppUrls';
import Lottie from 'lottie-react';
import animationData from 'assets/Lottie/no_data.json';
import CommonModal from 'components/common/Modal';
import { Box } from '@mui/system';
import crossIcon from 'assets/images/crossIcon.svg';

import LinkBaseIcon from 'assets/images/Campaigns/LinkSimple.svg';
import AssociationBaseIcon from 'assets/images/Campaigns/ShareFat.svg';
import BrandBaseIcon from 'assets/images/Campaigns/ShareFat-3.svg';
import DiscountBaseIcon from 'assets/images/Campaigns/SealPercent-1.svg';

import LinkBaseColorIcon from 'assets/images/Campaigns/LinkSimple-1.svg';
import AssociationBaseColorIcon from 'assets/images/Campaigns/ShareFat-1.svg';
import BrandBaseColorIcon from 'assets/images/Campaigns/ShareFat-2.svg';
import DiscountBaseColorIcon from 'assets/images/Campaigns/SealPercent.svg';

import { countryCityDropdownCallAPI } from 'store/CountryCityList/action';
import { useDispatch, useSelector } from 'react-redux';
import { getCampaignTypeCallAPI } from 'store/SuperAdmin/getCampaignType/action';
import { getCampaignListCallAPI } from 'store/SuperAdmin/getCampaign/action';
import moment from 'moment';
import { useConfirm } from 'material-ui-confirm';
import { deleteCampaignSuperAdminCallAPI } from 'store/SuperAdmin/deleteCampaign/action';
import ToastNotification from 'components/common/Toast';
import { getAppointmentDaysProviderCallAPI } from 'store/AppointmentDaysList/action';
import { updateCampaignStatusCallAPI } from 'store/SuperAdmin/updateCampaignStatus/action';
import { ShimmerBox, ShimmerCircle } from 'components/common/Shimmer';

const Campaigns = () => {
  const navigate = useNavigate();
  const intl = useIntl();
  const dispatch = useDispatch();
  const confirm = useConfirm();
  const [conf, setConf] = ToastNotification();

  const { locale } = useContext(LocaleContext);
  const [checked, setChecked] = useState(false);
  const [isModalActive, setIsModalActive] = useState(false);
  const [selectedItems, setSelectedItems] = useState('');
  const [campaignTypeData, setCampaignTypeData] = useState([]);

  useEffect(() => {
    getCountryCityList();
    getAppointmentDaysList();
    getCampaignTypeList();
    getCampaignList();
  }, []);

  const getCountryCityList = () => {
    dispatch(countryCityDropdownCallAPI({}, { naviagte: navigate }));
  };

  const getAppointmentDaysList = () => {
    dispatch(
      getAppointmentDaysProviderCallAPI(
        {},
        {
          naviagte: navigate,
        }
      )
    );
  };

  const getCampaignListData = useSelector(
    (state) => state?.getCampaignListReducer?.data?.data
  );
  const campaignLoading = useSelector(
    (state) => state?.getCampaignListReducer?.loading
  );

  const [campaignListData, setCampaignListData] = useState(
    getCampaignListData ? getCampaignListData : []
  );

  const getCampaignTypeList = () => {
    dispatch(
      getCampaignTypeCallAPI(
        {},
        {
          run: true,
          handleFunction: (res) => handleCampaignTypeSuccess(res),
          naviagte: navigate,
        }
      )
    );
  };

  const getCampaignList = () => {
    dispatch(
      getCampaignListCallAPI(
        {},
        {
          run: true,
          handleFunction: (res) => handleCampaignListSuccess(res),
          naviagte: navigate,
        }
      )
    );
  };

  const handleCampaignTypeSuccess = (res) => {
    const filteredData = res?.data?.data?.filter(
      (item) => item.name !== 'Discount Based'
    );

    setCampaignTypeData(filteredData);
  };

  const handleCampaignListSuccess = (res) => {
    setCampaignListData(res?.data?.data);
  };

  const handleSwitchChange = (key) => {
    let body = { compaign_id: key?.id, status: !key?.is_active };
    dispatch(
      updateCampaignStatusCallAPI(body, {
        run: true,
        handleFunction: (res) => handleCampaignStatusSuccess(res),
        naviagte: navigate,
      })
    );
  };

  const handleCampaignStatusSuccess = (res) => {
    setConf({
      msg: res?.data?.message,
      variant: 'success',
    });
    getCampaignList();
  };

  const handleCloseModel = () => {
    setIsModalActive(false);
  };

  const selectItem = (item, index) => {
    let items = [...selectedItems];
    setSelectedItems(items);
    if (items.includes(item)) {
      let index = items.indexOf(item);
      items.splice(index, 1);
    } else {
      items.pop(item);
      items.push(item);
    }
  };

  const handleSelectNavigate = (post) => {
    switch (post?.slug) {
      case 'link-based':
        navigate(superAdminAddLinkedCampaign(locale), {
          state: { campaignTypeId: post?.id },
        });
        break;
      case 'association-based':
        navigate(superAdminAddAssociationCampaign(locale), {
          state: { campaignTypeId: post?.id },
        });
        break;
      case 'brand-based':
        navigate(superAdminAddBrandCampaign(locale), {
          state: { campaignTypeId: post?.id },
        });
        break;
      case 'discount-based':
        navigate(superAdminAddDiscountCampaign(locale), {
          state: { campaignTypeId: post?.id },
        });
        break;
    }
  };

  const getCampaignTypeIcon = (post) => {
    switch (post?.slug) {
      case 'link-based':
        return LinkBaseIcon;
      case 'association-based':
        return AssociationBaseIcon;
      case 'brand-based':
        return BrandBaseIcon;
      case 'discount-based':
        return DiscountBaseIcon;
    }
  };

  const getCampaignTypeColorIcon = (post) => {
    switch (post?.slug) {
      case 'link-based':
        return LinkBaseColorIcon;
      case 'association-based':
        return AssociationBaseColorIcon;
      case 'brand-based':
        return BrandBaseColorIcon;
      case 'discount-based':
        return DiscountBaseColorIcon;
    }
  };

  const handleEditCampaign = (key) => {
    switch (key?.campaign_type?.slug) {
      case 'link-based':
        navigate(superAdminAddLinkedCampaign(locale), {
          state: { campaignData: key, campaignTypeId: key?.campaign_type?.id },
        });
        break;
      case 'association-based':
        navigate(superAdminAddAssociationCampaign(locale), {
          state: { campaignData: key, campaignTypeId: key?.campaign_type?.id },
        });
        break;
      case 'brand-based':
        navigate(superAdminAddBrandCampaign(locale), {
          state: { campaignData: key, campaignTypeId: key?.campaign_type?.id },
        });
        break;
      case 'discount-based':
        navigate(superAdminAddDiscountCampaign(locale), {
          state: { campaignData: key, campaignTypeId: key?.campaign_type?.id },
        });
        break;
    }
  };

  const handleDeleteCampaign = (data, index) => {
    confirm({
      title: 'Confirm Delete',
      description: 'Are you sure you want to delete Campaign ?',
      confirmationText: 'Yes',
      cancellationText: 'No',
      dialogProps: { maxWidth: 'xs' },
      confirmationButtonProps: {
        sx: {
          bgcolor: '#292D32',
          color: '#FFFFFF',
          borderRadius: '0px',
          border: '1px solid #292D32',
          '&:hover': { bgcolor: '#292D32' },
        },
      },
      cancellationButtonProps: {
        sx: {
          bgcolor: 'transparent',
          color: '#292D32',
          borderRadius: '0px',
          border: '1px solid #292D32',
        },
      },
    })
      .then(() => handleConfirmDeleteCampaign(data))
      .catch(() => console.log('Deletion cancelled.'));
  };

  const handleConfirmDeleteCampaign = (data) => {
    dispatch(
      deleteCampaignSuperAdminCallAPI(
        {},
        {
          id: data?.id,
          run: true,
          handleFunction: (res) => handleDeleteSucess(res),
          navigate: navigate,
        }
      )
    );
  };

  const handleDeleteSucess = (res) => {
    setConf({
      msg: res?.data?.message,
      variant: 'success',
    });
    getCampaignList();
  };

  const BannerLottie = ({ bannerImage }) => {
    const [animationData, setAnimationData] = useState(null);

    useEffect(() => {
      const fetchLottieJSON = async () => {
        if (bannerImage?.fileType === 'J' && bannerImage?.file_url) {
          try {
            const response = await fetch(bannerImage.file_url);
            const data = await response.json();

            if (data?.layers?.length) {
              setAnimationData(data);
            } else {
              console.warn('Invalid Lottie JSON:', data);
            }
          } catch (error) {
            console.error('Error loading Lottie JSON:', error);
          }
        }
      };

      fetchLottieJSON();
    }, [bannerImage]);

    if (!animationData) {
      return (
        <img
          src={Avtar}
          alt="icon"
          style={{
            height: '60px',
            width: '60px',
            borderRadius: '50%',
          }}
        />
      );
    }

    return (
      <Lottie
        animationData={animationData}
        loop={true}
        style={{
          height: '60px',
          width: '60px',
          borderRadius: '50%',
        }}
      />
    );
  };

  return (
    <Row className="bc-F2F3F6 m-0 p-0">
      <Col
        className={
          locale === 'en'
            ? 'commonEnContainer lg:ml-left'
            : 'commonArContainer lg:mr-right'
        }
      >
        <div className="flex justify-between items-center">
          <h2 className="fc-292D32 fs-32 fw-400 ff-Akkurat_Bold m-0">
            <FormattedMessage id="Campaigns" />
          </h2>
          {!campaignLoading && (
            <ReusableButton
              fullWidth={false}
              variant="contained"
              color="#F5F5F5"
              fontSize="16px"
              fontWeight="400"
              padding="12px 24px"
              height="48px"
              bgColor="#292D32"
              fontFamily="Akkurat"
              onClick={() => setIsModalActive(true)}
            >
              <FormattedMessage id="Create Campaign" />
            </ReusableButton>
          )}
        </div>

        <Row className="mt-3 listHeader m-0 p-0 flex items-center">
          <Col lg={4} md={6} sm={12}>
            <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold">
              <FormattedMessage id="Campaign Name" />
            </p>
          </Col>
          <Col lg={2} md={6} sm={12}>
            <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold">
              <FormattedMessage id="Country/City" />
            </p>
          </Col>
          <Col lg={2} md={6} sm={12}>
            <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold">
              <FormattedMessage id="Campaign Type" />
            </p>
          </Col>
          <Col lg={2} md={6} sm={12}>
            <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold">
              <FormattedMessage id="Status" />
            </p>
          </Col>
          <Col lg={2} md={6} sm={12}>
            <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold">
              <FormattedMessage id="Actions" />
            </p>
          </Col>
        </Row>

        <Row className="bc-FFFFFF m-0 p-0">
          {campaignLoading ? (
            <>
              {[1, 2, 3, 4, 5].map((item) => (
                <Row key={item} className="m-0 flex items-center listCampaign">
                  <Col lg={4} md={6} sm={12}>
                    <Stack
                      direction="horizontal"
                      gap={3}
                      className="items-center"
                    >
                      <ShimmerCircle size="60px" />
                      <div>
                        <ShimmerBox width="200px" height="16px" />
                        <div className="flex gap-2 mt-1 mb-1">
                          <ShimmerBox width="30px" height="24px" />
                          <ShimmerBox width="30px" height="24px" />
                          <ShimmerBox width="30px" height="24px" />
                        </div>
                        <ShimmerBox width="250px" height="12px" />
                      </div>
                    </Stack>
                  </Col>

                  <Col lg={2} md={6} sm={12}>
                    <ShimmerBox width="100px" height="12px" />
                    <ShimmerBox width="100px" height="12px" className="mt-1" />
                  </Col>

                  <Col lg={2} md={6} sm={12}>
                    <Stack
                      direction="horizontal"
                      gap={3}
                      className="items-center"
                    >
                      <ShimmerBox width="24px" height="24px" />
                      <ShimmerBox width="120px" height="12px" />
                    </Stack>
                  </Col>

                  <Col lg={2} md={6} sm={12}>
                    <ShimmerBox width="50px" height="20px" />
                  </Col>

                  <Col lg={2} md={6} sm={12}>
                    <Stack
                      direction="horizontal"
                      gap={3}
                      className="items-center"
                    >
                      <ShimmerBox width="24px" height="24px" />
                      <ShimmerBox width="24px" height="24px" />
                    </Stack>
                  </Col>
                </Row>
              ))}
            </>
          ) : campaignListData?.length > 0 ? (
            campaignListData.map((key, index) => (
              <Row className="m-0 flex items-center listCampaign">
                <Col lg={4} md={6} sm={12}>
                  <Stack
                    direction="horizontal"
                    gap={3}
                    className="items-center"
                  >
                    {key?.english_banner_image?.fileType === 'I' && (
                      <img
                        src={key?.english_banner_image?.file_url}
                        alt="icon"
                        style={{
                          height: '60px',
                          width: '60px',
                          borderRadius: '50%',
                        }}
                      />
                    )}

                    {key?.english_banner_image?.fileType === 'V' && (
                      <img
                        src={AvtarVideoIcon}
                        alt="icon"
                        style={{
                          height: '60px',
                          width: '60px',
                          borderRadius: '50%',
                        }}
                      />
                    )}

                    {key?.english_banner_image?.fileType === 'J' && (
                      <BannerLottie bannerImage={key.english_banner_image} />
                    )}

                    <div>
                      <p className="p-0 m-0 fs-16 fc-292D32 fw-600 ff-Akkurat_Bold">
                        {key?.name}
                      </p>
                      <div className="flex gap-2 mt-1 mb-1">
                        {key?.weekday?.length > 0 &&
                          key.weekday.map((item, index) => (
                            <div className="weekdays bc-808080">
                              <p className="p-0 m-0 fs-12 fc-FFFFFF fw-500 ff-Akkurat">
                                {item?.name?.substring(0, 2)}
                              </p>
                            </div>
                          ))}
                      </div>
                      <p className="p-0 m-0 fs-12 fw-400 fc-292D32 ff-Akkurat">
                        {`${moment(key?.start_date).format('DD MMM YYYY')} - ${moment(key?.end_date).format('DD MMM YYYY')}`}
                      </p>
                    </div>
                  </Stack>
                </Col>

                <Col lg={2} md={6} sm={12}>
                  <p className="p-0 m-0 fs-12 fc-292D32 fw-400 ff-Akkurat">
                    {key?.country?.name}
                  </p>
                  <p className="p-0 m-0 fs-12 fc-292D32 fw-400 ff-Akkurat">
                    {key?.cities?.name}
                  </p>
                </Col>

                <Col lg={2} md={6} sm={12}>
                  <Stack
                    direction="horizontal"
                    gap={3}
                    className="items-center"
                  >
                    <img
                      src={
                        key?.campaign_type?.slug === 'link-based'
                          ? LinkBaseIcon
                          : key?.campaign_type?.slug === 'association-based'
                            ? AssociationBaseIcon
                            : key?.campaign_type?.slug === 'brand-based'
                              ? BrandBaseIcon
                              : DiscountBaseIcon
                      }
                      alt="icon"
                      style={{ height: '24px', width: '24px' }}
                    />
                    <p className="p-0 m-0 fs-12 fc-292D32 fw-400 ff-Akkurat">
                      {key?.campaign_type?.name}
                    </p>
                  </Stack>
                </Col>

                <Col lg={2} md={6} sm={12}>
                  <SwitchInput
                    label={true}
                    checked={key?.is_active}
                    onChange={() => handleSwitchChange(key)}
                    color="secondary"
                  />
                </Col>

                <Col lg={2} md={6} sm={12}>
                  <Stack
                    direction="horizontal"
                    gap={3}
                    className="items-center "
                  >
                    <img
                      className="cursor-pointer"
                      src={EditUnderlineIcon}
                      alt="icon"
                      style={{ height: '24px', width: '24px' }}
                      onClick={() => handleEditCampaign(key)}
                    />
                    <img
                      className="cursor-pointer"
                      src={trash}
                      alt="icon"
                      style={{ height: '24px', width: '24px' }}
                      onClick={() => handleDeleteCampaign(key)}
                    />
                  </Stack>
                </Col>
              </Row>
            ))
          ) : (
            <Row className="bc-FFFFFF m-0 p-50 flex justify-center items-center">
              <Lottie
                animationData={animationData}
                loop={true}
                style={{ height: '200px', width: '200px' }}
              />
            </Row>
          )}
        </Row>

        {/* campaign Select Modal*/}
        <CommonModal
          padding={'16px'}
          width={'500px'}
          modalActive={isModalActive}
          handleClose={() => handleCloseModel()}
          innerContent={
            <Box>
              <Row>
                <Col xs={12} md={12}>
                  <div className="flex justify-end items-center">
                    <img
                      src={crossIcon}
                      alt={'icon'}
                      style={{
                        cursor: 'pointer',
                        height: '32px',
                        width: '32px',
                      }}
                      onClick={() => handleCloseModel()}
                    />
                  </div>
                </Col>

                <Col className="px-5">
                  {campaignTypeData?.length > 0 &&
                    campaignTypeData.map((post, index) => (
                      <>
                        <div
                          className={`flex items-center post_type ${
                            selectedItems && selectedItems[0].id == post.id
                              ? 'selected'
                              : 'unselect'
                          }`}
                          onClick={() => {
                            selectItem(post, index);
                            handleSelectNavigate(post);
                          }}
                        >
                          <div className="me-3">
                            <img
                              src={getCampaignTypeIcon(post)}
                              alt="icon"
                              class="icon"
                              style={{ height: '24px', width: '24px' }}
                            />
                            <img
                              src={getCampaignTypeColorIcon(post)}
                              alt="icon"
                              class="icon-hover"
                              style={{ height: '24px', width: '24px' }}
                            />
                          </div>

                          <p className="cursor-pointer fs-22 p-0 m-0">
                            {post.name}
                          </p>
                        </div>
                        <hr
                          style={{ border: '1px solid #ccc', margin: '16px 0' }}
                        />
                      </>
                    ))}
                </Col>
              </Row>
            </Box>
          }
        />
        {/* campaign Select Modal  */}
      </Col>
    </Row>
  );
};

export default Campaigns;
